import React, { useState, useRef, useEffect } from 'react'
import axios from 'axios';
import Select from "react-select";
import Loader from "../../comman/Loader";
import {baseUrl, purchaseProductList, milkType} from "../../comman/config";
import { useNavigate, Link } from 'react-router-dom';

export default function Form({detail}) {
    const user_id = localStorage.getItem("userId");
    const today = new Date().toISOString().split("T")[0];
    const [formData, setFormData] = useState({
        date : today,
        product_type : '',
        milk_type:'',
        product_name: '',
        quantity : '',
        price : 0,
        user_id:user_id
    });
    const [validationErrors, setValidationErrors] = useState({
        date: false,
        product_type: false,
        milk_type: false,
        product_name: false,
        quantity: false,
        price: false,
        
    });
    const [popupOpen , setPopupOpen] = useState(false);
    const [productList, setProductList] = useState([]);
    const formRef = useRef(null);
    
    useEffect(() => {
        getProductList();
    }, []);
    
    const navigate = useNavigate();
    
    useEffect(() => {
        if(detail && productList.length > 0){
            const productObj = productList.find((val) => val.id == detail[0].product_id);
            const product = productObj ? {value : productObj.id, label : productObj.name} : {value : "", label : ""};
            setFormData({
                date: detail[0].date || today,
                price: detail[0].price ||0,
                quantity : detail[0].quantity || 0,
                product_name : product || '',
                product_type : purchaseProductList.find((item) => item.value == detail[0].product_type),
                milk_type: milkType.find((item) => item.value == detail[0].milk_type),
                db_id: detail[0]?.id ?? 0
            });
        }
    }, [detail, productList]);



    const handleSubmit = async (e) => {
        e.preventDefault();
        const newValidationErrors = {
            date: formData.date === '',
            product_type : !formData.product_type.value,
            milk_type : (formData.product_type.value == 1 && !formData.milk_type.value),
            product_name : (formData.product_type.value == 2 && !formData.product_name.value),
            quantity : formData.quantity === '' || formData.quantity == 0,
            price : formData.price === '' || formData.price == 0,
            
        };
        setValidationErrors(newValidationErrors);
        const hasErrors = Object.values(newValidationErrors).some((error) => error);
        if (hasErrors) {
            
            // Find the first invalid input element
            const firstInvalidInput = formRef.current.querySelector('.invalid');
            if (firstInvalidInput) {
              // Scroll to the first invalid input element
              firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }else {
            let url;
            try {
                setPopupOpen(true);
                if(detail){
                    url = `shop_purchase/edit/${detail[0].id}`;
                }else{
                    url = "shop_purchase/add";
                }
                await axios.post(`${baseUrl}/${url}`,{
                    formData: formData,
                });
                setPopupOpen(false);
                navigate("/shop_purchase/list");
            } catch (error) {

                setPopupOpen(false);
                console.log(error);
                
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
    
            }));
      
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false
        }));
    };

    const getProductList = async ()=> {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/shop_product/list_all?user_id=${user_id}`);
        setPopupOpen(false);
        setProductList(response.data.data);
    }

    const handleSelectChange = (data, option) => {
        if(option.name === "product_type"){
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,
                ...(data.value === 1 ? { product_name: "" } : { milk_type: "" })
              }));
              
        }else{
            setFormData((prevData) => ({
                ...prevData,
                [option.name]: data,
              }));
        }
        
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [option.name]: false,
        }));
      };
    

  return (
 
 <form ref={formRef}>
    {popupOpen && (
                     <Loader /> 
                ) }
                <div className="space-y-12">
                    <div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="date" className="block text-sm font-medium leading-6 text-gray-900">Date</label>
                                <div className="mt-2">
                                <input
                                    type="date"
                                    name="date"
                                    id="date"
                                    value={formData.date}
                                    onChange={handleInputChange}
                                    className={`block w-full rounded-md border ${
                                        validationErrors.date ? "border-red-500" : "border-gray-300"
                                    } py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                />
                                </div>
                                {validationErrors.date && <div className="text-red-500">Please enter a date.</div>}
                            </div>
                            
                            <div className="sm:col-span-2">
                                <label htmlFor="quantity" className="block text-sm font-medium leading-6 text-gray-900">Quantity (Ltr.)</label>
                                <div className="mt-2">
                                    
                                    <input 
                                      id="quantity"
                                      name="quantity"
                                      type="number"
                                      placeholder='Quantity (ltr.)'
                                      step="0.01"
                                      value={formData.quantity}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.quantity ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.quantity && <div className="text-red-500">Please enter quantity.</div>}
                            </div>
                        </div>
                       
                         <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                         <div className="sm:col-span-2">
                                <label htmlFor="product_type" className="block text-sm font-medium leading-6 text-gray-900">Product Type</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.product_type}
                                        name="product_type"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={purchaseProductList.map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                                {validationErrors.product_type && <div className="text-red-500">Please select a product.</div>}
                            </div>
                         {
                            formData.product_type.value == 1 &&<div className="sm:col-span-2">
                                <label htmlFor="milk_type" className="block text-sm font-medium leading-6 text-gray-900">Milk Type</label>
                                <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.milk_type}
                                        name="milk_type"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={milkType.map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                                {validationErrors.milk_type && <div className="text-red-500">Please select a milk type.</div>}
                            </div>}
                            {
                            formData.product_type.value == 2 &&<div className="sm:col-span-2">
                            <label htmlFor="product_name" className="block text-sm font-medium leading-6 text-gray-900">Product name</label>
                            <div className="mt-2">
                                    <Select
                                        classNamePrefix="select"
                                        value={formData.product_name}
                                        name="product_name"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={productList.map((item) => ({
                                            value: item.id,
                                            label: item.name,
                                        }))}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label
                                            .toLowerCase()
                                            .includes(inputValue.toLowerCase());
                                        }}
                                    />
                                </div>
                            {validationErrors.product_name && <div className="text-red-500">Please enter a product name.</div>}
                        </div>}
                        </div>

                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="price" className="block text-sm font-medium leading-6 text-gray-900">Price</label>
                                <div className="mt-2">
                                    
                                    <input 
                                      id="price"
                                      name="price"
                                      type="number"
                                      step="0.01"
                                      placeholder='Price'
                                      value={formData.price}
                                      onChange={handleInputChange}
                                      onWheel={(e) => e.target.blur()}
                                      className={`block w-full rounded-md border ${validationErrors.price ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}
                                        
                                    />
                                    
                                </div>
                                {validationErrors.price && <div className="text-red-500">Please enter price.</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-6 flex items-center justify-end gap-x-6">
                    <Link to="/shop_purchase/list">
                        <button type="button" className="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
                    </Link>
                    <button
                    onClick={handleSubmit}
                      type="submit"
                      className="rounded-md bg-blue-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Save
                    </button>
                </div>
            </form>
            )
        }